/**
 *
 * ServiceLinks
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import ResourceItemInfoButton from 'components/ResourceItemInfoButton';
import useSiteCopySelector from 'components/useSiteCopySelector';
import ResourceLinks from 'components/ResourceLinks';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Banner211Link from './Banner211Link';

const useStyles = makeStyles(theme => ({
  bannerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3.75rem',
  },
  serviceLinkHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
    [theme.breakpoints.down('sm')]: {
      padding: '0 18px !important',
    },
  },
}));

function ServiceLinks({ data, section }) {
  const classes = useStyles();
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);
  const item = _get(data, '0', {});
  const {
    fields: { name, url, type, banner211Link },
  } = item;
  const trackCommonProps = {
    trackMessage: 'Resource Page - Exited',
    resourceType: 'service',
    name,
    subtype: type,
    data: item,
  };

  if (!_isEmpty(banner211Link)) {
    return (
      <div className={classes.bannerContainer}>
        <Banner211Link
          url={banner211Link}
          linkLabel={_get(
            resourceItemPageSiteCopy,
            'pageCopy.service211Banner.linkLabel',
          )}
          text={_get(
            resourceItemPageSiteCopy,
            'pageCopy.service211Banner.text',
          )}
        />
        <div className={classes.serviceLinkHeader}>
          <Typography variant="subtitle2" color="textPrimary">
            {_get(
              resourceItemPageSiteCopy,
              'pageCopy.service211Banner.serviceLinksHeader',
            )}
          </Typography>
          <ResourceItemInfoButton
            url={url}
            exitPage="website"
            type="website"
            banner211Link={banner211Link}
            label={_get(
              resourceItemPageSiteCopy,
              'pageCopy.service211Banner.officialSiteLabel',
            )}
            showLeavingDialog
            {...trackCommonProps}
          />
        </div>
      </div>
    );
  }

  return (
    <ResourceLinks
      data={data}
      section={section}
      subtitle={_get(resourceItemPageSiteCopy, 'pageCopy.serviceLinksHeader')}
    >
      {url && (
        <ResourceItemInfoButton
          url={url}
          exitPage="website"
          type="website"
          showLeavingDialog
          {...trackCommonProps}
        />
      )}
    </ResourceLinks>
  );
}

ServiceLinks.propTypes = {
  data: PropTypes.object,
  section: PropTypes.string,
};

export default ServiceLinks;
